export default {
  methods: {
    handleResize() {
      const isMobile = window.innerWidth < 992;
      const isRSOpen = window.innerWidth >= 1200;
      this.$store.commit('navigationOpen/setIsMobile', isMobile, {
        root: true,
      });
      this.$store.commit('navigationOpen/setIsOpen', !isMobile, {
        root: true,
      });
      this.$store.commit('navigationOpen/setIsRSOpen', isRSOpen, {
        root: true,
      });
    },
    openRightSideBar() {
      this.$store.commit('navigationOpen/setIsRSOpen', true, {
        root: true,
      });
    },
    closeRightSideBar() {
      this.$store.commit('navigationOpen/setIsRSOpen', false, {
        root: true,
      });
    },
  },
  computed: {
    hasDataTableStat() {
      return (this.activeCustomDashboard?.allStatComponents || []).find((e) => e.show_data_in_table)
        ? true
        : false;
    },
  },
};
